// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2Hbpr","label":"Labeled_label__udRPP","divider":"Labeled_divider__1uuF2"};